import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { settingsApi } from '../../api/lib/settings';
import { gdprKeys } from '../../api/query-keys/gdpr';
import { GdprClauseType, GdprLanguage } from '../../api/types/gdpr';

export const useCreateGDPRClause = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['settings']);

  return useMutation({
    mutationFn: ({
      gdprClause,
      language,
      type,
    }: {
      gdprClause: string;
      language: GdprLanguage;
      type: GdprClauseType;
    }) => settingsApi.addGdprClause(gdprClause, language, type),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: gdprKeys.all,
      });
      onSuccess?.();
      toast.success(t('settings:gdpr.updateSuccess'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
